export * from "-!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=style&index=0&id=ea0f4bb0&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/error.vue?vue&type=style&index=0&id=ea0f4bb0&scoped=true&lang=css&
// module id = Jarb
// module chunks = 0